import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../admin/api';
import Icon from '../../admin/Icon';
import ThemeToggle from '../../admin/ThemeToggle';
import '../../admin/admin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { role } = await login(email, password);
      navigate(role === 'webmaster' ? '/portal/webmaster' : '/portal/manager', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <div className="admin-login-brand">
          <h1>JG Detailing</h1>
          <p className="admin-login-sub">Admin Sign In</p>
        </div>

        <div className="admin-field">
          <label htmlFor="admin-email">Email</label>
          <input
            id="admin-email"
            type="email"
            autoComplete="username"
            value={email}
            autoFocus
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </div>

        <div className="admin-field">
          <label htmlFor="admin-pw">Password</label>
          <div className="admin-input-wrap">
            <input
              id="admin-pw"
              type={showPw ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
            <button
              type="button"
              className="pw-toggle"
              onClick={() => setShowPw((v) => !v)}
              aria-label={showPw ? 'Hide password' : 'Show password'}
            >
              {showPw ? <Icon name="eye-off" size={17} /> : <Icon name="eye" size={17} />}
            </button>
          </div>
        </div>

        {error && <p className="admin-error">{error}</p>}

        <button type="submit" className="admin-primary-btn admin-login-btn" disabled={busy || !password}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>

        <p className="admin-login-foot">Managers can leave email blank.</p>
        <div className="admin-login-theme"><ThemeToggle /></div>
      </form>
    </div>
  );
};

export default AdminLogin;
